import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import * as S from './styles';
import { User } from 'interfaces/user';
import { useTranslation, usePermissions } from 'hooks';

import { translations } from './translations';
import { niceDate } from 'utils';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { LanguageState } from 'store/ducks/language';
import { AuthActions, AuthState } from 'store/ducks/auth';

interface IGridUsersProps {
  users: User[] | Record<string, any>[];
}

interface IUserProps {
  user: User | Record<string, any>;
  language: string;
}

const Item: React.FC<IUserProps> = ({ user, language }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { checkUserPermission } = usePermissions();
  const { loading } = useSelector<RootStateOrAny>(
    (state: any) => state.auth
  ) as AuthState;
  const havePermission = checkUserPermission('editUser');
  const canLoginAs =
    checkUserPermission('loginAsUser') || checkUserPermission('editUser');

  const handleLoginAs = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation();
      if (!canLoginAs) return;
      dispatch(
        // @ts-ignore action will be added to auth duck
        AuthActions.loginAsUserRequest({ userId: user.id })
      );
    },
    [dispatch, canLoginAs, user.id]
  );
  return (
    <S.ItemContainer
      onClick={() =>
        havePermission && history.push(`/settings/user/${user.id}`)
      }
    >
      <S.ItemContent pointer={havePermission}>
        <S.ItemValue>{user.id || '--'}</S.ItemValue>
        <S.ItemValue>
          {user.roles.length ? user.roles[0].name : '--'}
        </S.ItemValue>
        <S.ItemValue>{user.name || '--'}</S.ItemValue>
        <S.ItemValue>{user.email || '--'}</S.ItemValue>
        <S.ItemValue>
          {user.last_access
            ? niceDate({ dateString: user.last_access, language })
            : '--'}
        </S.ItemValue>
        {havePermission && (
          <S.ButtonDetail>
            <S.IconDetail />
          </S.ButtonDetail>
        )}
      </S.ItemContent>
    </S.ItemContainer>
  );
};

export const GridUsers: React.FC<IGridUsersProps> = ({ users = [] }) => {
  const { getTranslation } = useTranslation(translations);
  const { language } = useSelector<RootStateOrAny, LanguageState>(
    (state: any) => state.language
  );
  return (
    <S.Container>
      <S.Header>
        <S.Label>{getTranslation('id')}</S.Label>
        <S.Label>{getTranslation('tipo')}</S.Label>
        <S.Label>{getTranslation('nome')}</S.Label>
        <S.Label>{getTranslation('email')}</S.Label>
        <S.Label>{getTranslation('ultimoAcesso')}</S.Label>
      </S.Header>
      {users.length > 0 &&
        users.map((user) => (
          <Item user={user} key={user.id} language={language} />
        ))}
    </S.Container>
  );
};
